import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';

class WCGoalDropDown extends React.Component {

    updateField(event) {
        if (event.target.value.startsWith("*")) {
            let key = Object.keys(this.props.goalFavorites)
                .find(x => '* ' + this.props.goalFavorites[x].GFNAME === event.target.value);
            this.props.applyFavoriteGoal(this.props.noteId, this.props.entityKeyValue, this.props.goalFavorites[key].GFNO);
        } else {
            let key = Object.keys(this.props.masterGoals)
                .find(x => this.props.masterGoals[x].MGNAME === event.target.value);
            if (key === undefined) {
                this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.entityKeyValue, 'GOMGNO');
            } else {
                this.props.updateIntField(this.props.noteId, 'PTGOALS', 'GONO', this.props.entityKeyValue, 'GOMGNO', this.props.masterGoals[key].MGNO);
            }
        }
        if (this.props.onChange) {
            this.props.onChange(event);
        }
    }

    render() {
        return (
            <span>
                <select
                    title={this.props.title}
                    value={this.props.value ? this.props.value : -1}
                    name='GOMGNO'
                    className={this.props.className}
                    disabled={this.props.disabled}
                    onChange={(event) => this.updateField(event)}
                >
                    <option key={-1} value={-1}></option>
                    {Object.keys(this.props.goalFavorites)
                        .map(key => {
                            const result = this.props.goalFavorites[key];
                            return (
                                <option key={-1 * result.GFNO} value={'* ' + result.GFNAME} >{'* ' + result.GFNAME}</option>
                            )
                        })
                    }
                    {Object.keys(this.props.masterGoals)
                        .map(key => {
                            const result = this.props.masterGoals[key];
                            return (
                                <option key={result.MGNO} value={result.MGNAME} >{result.MGNAME}</option>
                            )
                        })
                    }
                </select>
            </span>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        applyFavoriteGoal: bindActionCreators(noteActions.applyFavoriteGoal, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteType = parseInt(ownprops.noteId.split("_")[0]);
    let pk = parseInt(ownprops.noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let pdc = undefined;
    if (noteType === 1 && state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC) {
        pdc = state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC;
    } else {
        pdc = state.entities.admissions[epno].jobReqPdc;
    }

    let mgnos = Object.keys(state.entities.masterData.PTMASTERGOALPDCXREF)
        .filter(key => {
            return (state.entities.masterData.PTMASTERGOALPDCXREF[key].GPXWPNO === pdc);
        })
        .map(key => state.entities.masterData.PTMASTERGOALPDCXREF[key].GPXMGNO);



    let masterGoals = Object.keys(state.entities.masterData.PTMASTERGOALS)
        .filter(key => {
            return mgnos.includes(state.entities.masterData.PTMASTERGOALS[key].MGNO) &&
                state.entities.masterData.PTMASTERGOALS[key].MGWORKCOMP === true;
        })
        .sort((a, b) => {
            return state.entities.masterData.PTMASTERGOALS[a].MGORDER - state.entities.masterData.PTMASTERGOALS[b].MGORDER;
        })
        .map(key => state.entities.masterData.PTMASTERGOALS[key]);

    masterGoals = Object.keys(masterGoals)
        .filter(x => masterGoals[x].MGNO !== parseInt(state.entities.masterData.PROPS['PTERO_IND_HEP_GOAL_ID'].PRVALUE))
        .map(x => masterGoals[x]);

    if (ownprops.includeCustom !== undefined && ownprops.includeCustom === false) {
        masterGoals = Object.keys(masterGoals)
            .filter(x => masterGoals[x].MGNO !== parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID_WC'].PRVALUE))
            .map(x => masterGoals[x]);
    }

    if (!state.entities.admissions[epno].allowFreeFormGoal) {
        // remove the freeform goal if its not allowed on this admission
        masterGoals = Object.keys(masterGoals)
            .filter(x => masterGoals[x].MGNO !== parseInt(state.entities.masterData.PROPS['PTERO_FREE_FORM_GOAL_ID'].PRVALUE))
            .map(x => masterGoals[x]);
    }

    let goalFavorites = Object.keys(state.entities.notes.PTGOALFAVORITES)
        .filter(key => {
            return (noteType === 1 && state.entities.notes.PTGOALFAVORITES[key].GFEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALFAVORITES[key].GFNTNO === pk)
        })
        .sort((a, b) => state.entities.notes.PTGOALFAVORITES[a].GFNAME.localeCompare(state.entities.notes.PTGOALFAVORITES[b].GFNAME))
        .map(key => state.entities.notes.PTGOALFAVORITES[key]);

    let disabled = noteType === 2 || noteType === 4 || noteType === 6 ||
        ((noteType === 3 || noteType === 5) && state.entities.notes.PTGOALS[ownprops.entityKeyValue].GOGONO !== null) ? true : false;

    return {
        value: state.entities.notes.PTGOALS[ownprops.entityKeyValue].GOMGNO ?
            state.entities.masterData.PTMASTERGOALS[state.entities.notes.PTGOALS[ownprops.entityKeyValue].GOMGNO].MGNAME :
            state.entities.notes.PTGOALS[ownprops.entityKeyValue].GOCUSTOM,
        masterGoals,
        goalFavorites,
        disabled

    };
}

const connectedWCGoalDropDown = connect(mapStateToProps, mapDispatchToProps)(WCGoalDropDown);
export { connectedWCGoalDropDown as WCGoalDropDown };